export default import.meta.ROLLDOWN_FILE_URL_DtjZl_JqXpOkzYScCvawLg